<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("TAKEAWAY_LOCATION_PARAMS")}}
                </div>


                <div class="form-group mt-2">
                    <label class="form-label">
                        {{ __t('API_TYPE')}}
                    </label>

                    <div>
                        <div class="input-group flex-nowrap">
                            <b-form-radio-group
                                id="btn-radios-1"
                                v-model="location.general_fields['api_type']"
                                button-variant="outline-primary"
                                :options="[
                                          { text: __t('TAKE_API'), value: 'api' },
                                          { text:  __t('TAKE_TABLET'), value: 'tablet' }
                                      ]"
                                name="radios-btn-default"
                                buttons
                            ></b-form-radio-group>
                        </div>
                    </div>
                </div>

                <div class="form-group mt-2" v-for="general_field in api_params">
                    <div v-if="general_field.key != 'api_type'">
                        <label class="form-label" >
                            {{general_field.title}}
                        </label>

                        <div>
                            <div class="input-group flex-nowrap">
                                <div class="input-group-prepend">
                                <span class="input-group-text">
                                    <i class="fal  fa-typewriter fs-xl" ></i>
                                </span>
                                </div>
                                <input :id="general_field.key" type="text" class="form-control" v-model="location.general_fields[general_field.key]">
                            </div>
                        </div>
                    </div>
                </div>

                <location_general_params :location="location"></location_general_params>

            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import Fuse from 'fuse.js';
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";
export default {
    name: "takeaway_general_tab",

    components : {
        Location_general_params,
        vSelect
    },

    props : {
        location : {
            type : Object
        }
    },

    mounted() {
        this.load_rest_list_takeaway();
    },

    data() {
        return {
            payments    : [],
            shippings   : [],
            categories  : [],
            restaurants : [],
        }
    },

    methods : {
        async load_rest_list_takeaway() {
            /*this.choices = [];
            await agr_api.get('choice/locations/'+ parseInt(this.location.parent_id) +'/accounts/').then(({data}) => {
                if (data.status === "operation_success") {
                    this.choice_accounts = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });*/
        },
    },

    computed: {

        general_fields() {

            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

        cur_api_type() {
            let type = '';
            this.general_fields.map(function($item) {
                if($item.key === 'api_type') {
                    type = $item.value;
                }
            });

            return type;
        },

        api_params() {

            if(this.cur_api_type === 'tablet') {
                return this.general_fields.filter(function($item) {
                    return $item.key === 'username' || $item.key === 'password';
                });
            }

            if(this.cur_api_type === 'api') {
                return this.general_fields.filter(function($item) {
                    return $item.key === 'tkwy_id' || $item.key === 'country';
                });
            }

            return [];
        },


    }
}
</script>

<style scoped>

</style>
